<template>
  <div class="progress-card" :class="{ 'loading': seasonLoading.progress }">
    <div class="progress-card__header">
      <h3 class="progress-card__title">{{ seasonInfo.title }}</h3>
      <span class="progress-card__period">{{ seasonInfo.startDate }} — {{ seasonInfo.endDate }}</span>
      <span class="progress-card__days-left">До конца сезона: {{ daysLeft }} дн.</span>
    </div>

    <ul v-if="myActivities.length" class="progress-card__activities">
      <li v-for="a in myActivities" :key="a.code" class="progress-card__activity">
        <div class="progress-card__activity-head">
          <span class="progress-card__activity-name">
            <i class="fa-solid" :class="a.icon"></i>
            {{ a.name }}
          </span>
          <span class="progress-card__activity-cluster">
            Кластер {{ a.clusterId }} ({{ clusterLabel(a.clusterId) }})
          </span>
          <span class="progress-card__activity-numbers">
            {{ a.passedKm }} / {{ a.goalKm }} км
          </span>
        </div>
        <div class="progress-card__activity-progress">
          <div class="progress-card__percent">{{ percentFor(a) }}%</div>
          <div class="progress-card__bar-wrap">
            <div class="progress-card__bar-track">
              <div class="progress-card__bar-fill" :style="{ width: Math.min(percentFor(a), 100) + '%' }"></div>
              <div class="progress-card__bar-diploma" :style="{ left: seasonInfo.diplomaThresholdPercent + '%' }">
                <span class="progress-card__bar-diploma-label">Порог диплома</span>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <div v-else class="progress-card__empty">
      Цели по активностям ещё не указаны.
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ProgressCard',
  computed: {
    ...mapGetters('season', ['myActivities', 'daysLeft', 'seasonInfo', 'clusterLabel', 'loading']),
    seasonLoading() {
      return this.loading
    },
  },
  methods: {
    percentFor(a) {
      if (!a.goalKm) return 0
      return Math.round((a.passedKm / a.goalKm) * 100)
    },
  },
}
</script>

<style>
.progress-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  margin-top: 40px;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,.07);
}

@media screen and (max-width: 1020px) {
  .progress-card {
    margin-top: 24px;
  }
}

.progress-card__header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.progress-card__title {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.progress-card__period {
  font-size: 14px;
  color: #888;
}

.progress-card__days-left {
  margin-left: auto;
  font-size: 13px;
  color: #6b7a8f;
}

.progress-card__activities {
  list-style: none;
  padding: 0;
  margin: 0;
}

.progress-card__activity {
  padding: 16px 0;
  border-top: 1px solid #EDF3FA;
}

.progress-card__activity:first-child {
  padding-top: 8px;
  border-top: none;
}

.progress-card__activity-head {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.progress-card__activity-name {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #012653;
}

.progress-card__activity-name i {
  width: 18px;
  text-align: center;
  color: #6b7a8f;
}

.progress-card__activity-cluster {
  font-size: 13px;
  color: #6b7a8f;
}

.progress-card__activity-numbers {
  margin-left: auto;
  font-size: 14px;
  font-weight: 600;
  color: #012653;
}

.progress-card__activity-progress {
  display: flex;
  align-items: center;
  gap: 16px;
}

.progress-card__percent {
  font-size: 22px;
  font-weight: 700;
  min-width: 56px;
}

.progress-card__bar-wrap {
  flex: 1;
  padding-bottom: 16px;
}

.progress-card__bar-track {
  position: relative;
  height: 12px;
  background: #e9ecef;
  border-radius: 6px;
  overflow: visible;
}

.progress-card__bar-fill {
  height: 100%;
  background: #28a745;
  border-radius: 6px;
  transition: width .3s;
}

.progress-card__bar-diploma {
  position: absolute;
  top: -4px;
  width: 2px;
  height: 20px;
  background: #c9952a;
  transform: translateX(-50%);
}

.progress-card__bar-diploma-label {
  position: absolute;
  top: 22px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 11px;
  color: #c9952a;
}

.progress-card__empty {
  padding: 16px 0;
  font-size: 14px;
  color: #6b7a8f;
}
</style>
